import { useEffect, useState } from 'react';
import debounce from 'lodash/debounce';

export const AutoSave = ({
  data,
  delay = 1000,
  isDataSaved = false,
  onDebouncedValueChange,
}) => {
  const [inputValue, setInputValue] = useState(data);
  const [debouncedValue, setDebouncedValue] = useState(inputValue);

  useEffect(() => {
    const debouncedSaveData = debounce((value) => {
      setDebouncedValue(value);
      onDebouncedValueChange(value);
    }, delay);

    if (inputValue && inputValue !== debouncedValue) {
      debouncedSaveData(inputValue);
    }
    return () => {
      debouncedSaveData.cancel();
    };
  }, [inputValue, debouncedValue, delay, onDebouncedValueChange]);

  useEffect(() => {
    setInputValue(data);
  }, [data]);

  return null;
};
